import { stringify as stringifyQuery } from "query-string";

interface PilboxOptions {
    w?: number;
    h?: number;
    mode?: "clip" | "crop" | "fill" | "scale";
    filter?: "nearest" | "bilinear" | "bicubic" | "antialias";
    fmt?: "jpeg" | "png" | "webp";
    bg?: string; // e.g. "fefefe"
    pos?:
        | "top-left"
        | "top"
        | "top-right"
        | "left"
        | "center"
        | "right"
        | "bottom-left"
        | "bottom"
        | "bottom-right"
        | "face";
    q?: number; // 1 - 100
    prog?: 0 | 1;
}

const IMAGE_FILE_EXTENSIONS = [".jpg", ".jpeg", ".gif", ".png"];

const stripTrailingSlash = (input: string) => (input.endsWith("/") ? input.slice(0, -1) : input);

const genPilboxURL = (pilboxHost: string = "", imageUrl: string, options: PilboxOptions) => {
    // default quality of 90 as pilbox default is 50
    // eslint-disable-next-line no-param-reassign
    options.q = options.q || 90;
    const currentExtension = IMAGE_FILE_EXTENSIONS.find((extension) => imageUrl.toLowerCase().includes(extension)) || "";
    const queryParams = {
        url: imageUrl,
        ...Object.keys(options).reduce((result: PilboxOptions, key: keyof PilboxOptions) => {
            if (options[key] === undefined) {
                return result;
            }
            return { ...result, [key]: options[key] };
        }, {})
    };
    return `${stripTrailingSlash(pilboxHost)}/image${currentExtension}?${stringifyQuery(queryParams)}`;
};

export { genPilboxURL };
